import { render } from "./base-button.vue?vue&type=template&id=a973b69c&scoped=true"
import script from "./base-button.vue?vue&type=script&lang=js"
export * from "./base-button.vue?vue&type=script&lang=js"

import "./base-button.vue?vue&type=style&index=0&id=a973b69c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a973b69c"]])

export default __exports__